import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: #00ff00;
  font-size: 1.2rem;
  text-align: left;
  padding: 20px;
  overflow: hidden;
`;

const BootText = styled.pre`
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 800px;
  animation: fadeIn 0.5s ease-in-out;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const BootSequence = () => {
  const [bootStage, setBootStage] = useState(0);
  const bootMessages = [
    "LUMON INDUSTRIES TERMINAL v9.73.05\n\nINITIALIZING SYSTEM...",
    "CHECKING HARDWARE INTEGRITY... OK\nLOADING KERNEL... OK\nINITIALIZING MEMORY... OK",
    "LOADING MACRODATA REFINEMENT SUBSYSTEM... OK\nINITIALIZING SECURITY PROTOCOLS... OK\nVERIFYING INTEGRITY... OK",
    "ESTABLISHING SECURE CONNECTION TO LUMON MAINFRAME...\nCONNECTION ESTABLISHED\nAUTHENTICATING...",
    "WELCOME TO LUMON INDUSTRIES\nMACRODATA REFINEMENT DIVISION\n\nPLEASE WAIT..."
  ];

  useEffect(() => {
    if (bootStage < bootMessages.length) {
      const timer = setTimeout(() => {
        setBootStage(bootStage + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [bootStage, bootMessages.length]);

  return (
    <BootContainer>
      {bootMessages.slice(0, bootStage + 1).map((message, index) => (
        <BootText key={index}>{message}</BootText>
      ))}
    </BootContainer>
  );
};

export default BootSequence;
